import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import ReactJsonPretty from "react-json-pretty";
import { Button } from "V2.0/common/button";
import WebhookUpdates from "../conversation_details/WebhookUpdates/WebhookUpdates";

export default function ExtractionDetails(props) {
  const { conversation } = props;
  const extractedData = conversation?.extractedData;

  const [open, setOpen] = useState(false);

  if (Object.keys(conversation).length === 0) {
    return null;
  }

  if (!extractedData) {
    return null;
  }

  if (Object.keys(extractedData).length === 0) {
    return null;
  }

  return (
    <>
      <div className="bg-white border rounded-lg p-4 mt-6 flex flex-col gap-y-2">
        <div className="relative">
          <div
            className="absolute inset-0 flex items-center"
            aria-hidden="true"
          >
            <div className="w-full border-t border-gray-300" />
          </div>
          <div className="relative flex justify-start">
            <span className="bg-white pr-2 text-sm text-gray-500">
              Extraction Details
            </span>
          </div>
        </div>
        <div className="mt-4 mb-2 mx-2 flex items-center justify-between text-sm">
          <span className="text-gray-500">Extracted Data</span>
          <Button
            plain
            onClick={() => setOpen(true)}
          >
            view
          </Button>
        </div>

        <WebhookUpdates webhookUpdates={conversation?.webhookUpdates} />
      </div>
      {open && (
        <Dialog
          size="5xl"
          open={open}
          onClose={() => setOpen(false)}
        >
          <DialogTitle>Extracted Data</DialogTitle>
          <DialogBody>
            <div className="w-full overflow-auto p-4 border rounded-lg">
              <ReactJsonPretty json={extractedData} />
            </div>
          </DialogBody>
          <DialogActions>
            <Button
              outline
              onClick={() => setOpen(false)}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
